var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomNotificationPin = function SvgCustomNotificationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.639 12.289.95 1.577c.37.607.437 1.33.19 1.985a2.279 2.279 0 0 1-1.425 1.377 18.02 18.02 0 0 1-5.72.922c-1.937 0-3.875-.304-5.718-.931-.703-.238-1.245-.732-1.473-1.368-.237-.646-.152-1.349.228-1.986l.96-1.586c.199-.342.38-1.007.38-1.396V8.479c0-2.204 1.282-4.113 3.135-5.035A2.813 2.813 0 0 1 11.606 2a2.78 2.78 0 0 1 2.451 1.416c.273.13.534.282.78.453a3.8 3.8 0 0 0 2.42 6.68v.334c.002.389.182 1.054.381 1.406ZM11.616 21c1.235 0 2.289-.788 2.688-1.89-.162.018-.313.038-.466.056-.128.02-.26.03-.394.041-.065.005-.13.01-.195.017-.532.047-1.073.075-1.615.075a18.85 18.85 0 0 1-1.643-.075 14.621 14.621 0 0 1-.674-.076 6.273 6.273 0 0 0-.183-.023 4.805 4.805 0 0 1-.197-.025c.133.39.36.77.665 1.054a2.817 2.817 0 0 0 2.014.846Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.166 6.75a2.85 2.85 0 1 1-5.7 0 2.85 2.85 0 0 1 5.7 0Z",
    fill: "#EE1B1B"
  })));
};

export default SvgCustomNotificationPin;